import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentCancelledPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div data-testid="payment-cancelled-page" className="min-h-screen bg-[#FAFAF8] py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-2xl">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 text-center">
          <div className="w-20 h-20 bg-[#FFEBEE] rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-[#FF6B6B]" />
          </div>
          
          <h1 className="text-2xl md:text-3xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
            Mokėjimas atšauktas
          </h1>
          
          <p className="text-[#718096] mb-8">
            Jūsų mokėjimas buvo atšauktas arba nepavyko. Galite bandyti dar kartą.
          </p>

          {orderId && (
            <p className="text-sm text-[#718096] mb-6">
              Užsakymo numeris: <span className="font-mono">{orderId}</span>
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/krepselis"
              className="inline-flex items-center justify-center bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-6 py-3 font-semibold transition-colors"
            >
              <RefreshCw className="w-5 h-5 mr-2" />
              Bandyti dar kartą
            </Link>
            <Link
              to="/parduotuve"
              className="inline-flex items-center justify-center bg-white text-[#4CAF50] border-2 border-[#4CAF50] hover:bg-[#E8F5E9] rounded-full px-6 py-3 font-semibold transition-colors"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Grįžti į parduotuvę
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-100">
            <p className="text-xs text-[#718096]">
              Kilus klausimams kreipkitės: info@tavoemocijos.lt
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
